// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"4e204156","370":"1645d955","392":"504c6923","411":"bf54874f","639":"124e7dc6","777":"86eee914","819":"49daae93","823":"c891231d","971":"67d487cb"}[chunkId] + ".chunk.js";
};